import React, { useCallback, useEffect, useState } from 'react';
import ListItem from '../../../../../elements/DEPRECATED_ListItem';
import SelectableListItem from '../../../../../elements/SelectableListItem';
import UserName from '../../../../../elements/UserName/UserName';

const TogglableUserList = props => {
    const {idProp = 'id', all, selected, onChange} = props,
        [listed, setListed] = useState([]);

    useEffect(() => {
        const newListed = [];

        // update previously listed
        for (let user of listed) {
            let newUser = all.find(user2 => user[idProp] == user2[idProp]);
            if (newUser) newListed.push(newUser);
        }

        // add new items
        for (let id of selected) {
            if (!listed.find(user => user[idProp] == id)) {
                let newUser = all.find(user => user[idProp] == id);
                if (newUser) newListed.push(newUser);
            }
        }

        // update list
        setListed(newListed);
    }, [all, selected]);

    const handleToggle = useCallback(
        id => {
            if (selected.includes(id)) {
                onChange(selected.filter(id2 => id2 != id));
            } else {
                onChange([...selected, id]);
            }
        },
        [selected]
    );

    return (
        <>
            {listed.map(user => (
                <SelectableListItem key={user[idProp]} checked={selected.includes(user[idProp])} onChange={() => handleToggle(user[idProp])}>
                    <ListItem tagName="div" icon={user.photo_url} altIcon="img/no_avatar.png">
                        <div className="text name bold">
                            <UserName user={user} />
                        </div>
                        <div className="text position">{user.position}</div>
                        <div className="text company">{user.company}</div>
                    </ListItem>
                </SelectableListItem>
            ))}
        </>
    );
};

export default TogglableUserList;
